import React from "react";
import { Page, Card } from "react-onsenui";
// import Toolbar from "../components/Toolbar";

export default class AboutUsPage extends React.Component {
  // renderToolbar() {
  //   const { navigator } = this.props;
  //   return <Toolbar pageName="About Us" navigator={navigator} /> ;
  // }

  render() {
    return (
      // <Page renderToolbar={this.renderToolbar.bind(this)}>
        <Page><Card>
          <h3>About DrugsPRO©️ by PRO Test©️</h3>
       <p>
            The best way to avoid substance risk is to avoid drug use, but that is not always possible. The information provided in this app is intended for harm reduction, particularly overdose and addiction prevention. We do not condone or condemn use of drugs, but consumption of psychoactive substances is always an avoidable health risk.
          </p>
          <p>
            Never assume any substance can be fully safe. Concentration, purity and
            adulteration vary greatly, even in case of samples aquired from the same source
            or bearing seemingly the same characteristics. Pure drugs are often lethal too.
          </p>
          <p>
            The publisher of <b>DrugsPRO</b> strongly advises against the use of
            any psychoactive substance - either legal or illegal. Many of the substances listed are illegal under
            domestic or international law. Posessing, buying or selling
            such compounds is punishable by law.
          </p>
        </Card>        <Card>
          <h3>Disclaimer</h3><p>
          <b>Sources:</b> Most drug combinations, doses, effects and descriptions come from TripSit (see https://combo.tripsit.me/) and PsychonautWiki. Reagent resuls are compiled from public and private data. Substance map is based on Universe of Drugs made by Espolea. Tryptamine / lysergamide dosage calculator based on code by CyberOxide. All presented information information is only intended for a quick overview and reference, it is necessary for users to perform more individual research before making any decision.

          </p><p><b>Reagent test kits</b> can indicate PRESENCE, but not QUANTITY. Mixtures can be detected with reagents only if an adulterant causes a
          darker color change than the expected substance (check in the app). PRO Test's multi reagent kits are expertly designed for detecting cuts. To reveal all ingredients and estimate their amount pair reagents with a TLC purity test kit. Use test strips to detect even trace amount of fentanyl, nitazene or xylazine. A positive or negative test result does not indicate if a substance is safe.
          No substance is 100% safe.</p>
        </Card>        <Card>
        <h3>Acknowledgements</h3> 
        <p><b>DrugsPRO</b> would never had been possible without the following heroes of harm reduction: <b>Cyrilio</b> (initial database), 
        <b>Endlessness</b> from DMT-Nexus (analytical methodology), <b>Marcin Biegun</b> (React development), <b>Wm. J. Holcomb</b> (share feature), <b>Bunk Police</b> (reagent research), <b>TripSit.me</b> (database), <b>PsychonautWiki.org</b> (database), <b>/r/ReagentTesting</b> community (feedback).
</p><p>
        We dedicate this app to all passionate harm reduction enthusiasts. We especially thank everyone who share publicly their drug checking results, we could not had made it without you. As Alexander "Sasha" Shulgin wrote in TiHKaL: "Industry [is] benefiting economically in the War on Drugs, by charging inflated prices for reference and research samples." We protest and will keep fighting for a safer tomorrow.

        </p>
        </Card>      <Card>
          <h3>DrugsPRO is a project by:</h3>
          <div>
            <a
              href="https://protestkit.eu/"
              target="_blank"
              rel="noopener noreferrer"
            >
              protestkit.eu
            </a>
          </div><div><b>PRO Test</b></div>
          <div>Chemical Safet sp. z o.o.</div>
          <div>ul. Szaserów 38</div>
          <div>04-294 Warszawa</div>
          <div>POLAND</div>
          <br></br>
            <div>Message us!</div>
          <div><a href="mailto:testy@protestkit.eu">testy@protestkit.eu</a></div>

        </Card>
      </Page>
    )}}
